import { memo, useEffect } from "react"
import { toast } from "react-toastify"

import { getVoucherError } from "@trueskin-web/functions"
import { voucherService } from "@trueskin-web/services"

const VoucherMessage = ({ voucher, error = "DEFAULT" }) => {
  useEffect(() => {
    const appliedVoucher = voucherService.getAppliedVoucher()

    if (!appliedVoucher) {
      return
    }

    const message = voucher
      ? voucher.message
      : getVoucherError({
          message: error,
          voucher: appliedVoucher.code,
        })

    toast(message, {
      toastId: appliedVoucher.code,
      onOpen: voucherService.removeAppliedVoucher(),
    })
  }, [voucher, error])

  return null
}

export default memo(VoucherMessage)
